import React from 'react'
import { LandingList } from './list/page'

export const LandingsPage: React.FC = (): JSX.Element => {
  return <LandingList />
}
